import { render, staticRenderFns } from "./TypeIndicator.vue?vue&type=template&id=3d10bd7e"
import script from "./TypeIndicator.vue?vue&type=script&lang=js"
export * from "./TypeIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports